import type { RouteRecordRaw, Router } from 'vue-router'
import { MODULE_ACCESS } from '@/modules/Core/constants/adminAccess'

const ShipmentRoutes: RouteRecordRaw = {
  path: '/shipment',
  name: 'ShipmentModulePages',
  redirect: { name: '' },
  children: [
    {
      path: '',
      name: 'ManageShipmentRoute',
      component: () => import('./views/ManageShipmentView.vue'),
      meta: {
        title: 'محموله‌ها',
      },
    },
    {
      path: 'view/:id',
      name: 'ViewShipmentRoute',
      component: () => import('./views/ShipmentDetailsView.vue'),
      meta: {
        title: 'جزئیات محموله',
        pageHasBack: true,
      },
    },
  ],
  meta: {
    layout: 'Default',
    allowedRoles: MODULE_ACCESS.shipment,
  },
}

export default (router: Router) => {
  router.addRoute(ShipmentRoutes)
}
